<template>
  <div>
    <v-button
      raised
      class="new-post-button v-toolbar__button ml-1 p-2"
      @click="openPostCreator"
    >
      <v-icon icon="add_circle_outline" size="1.2rem" class="mr-1"></v-icon>
      {{ $t("components.messageThread.newPostButton.newPost") }}
    </v-button>
    <post-creator-modal
      v-if="showPostCreator"
      :message-thread-id="messageThreadId"
      @posted="ts => $emit('posted', ts)"
      @close="handleClose"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  components: {
    PostCreatorModal: () =>
      import("@/components/message-thread/PostCreatorModal")
  },

  props: {
    messageThreadId: { type: [String, Number], required: true }
  },

  data() {
    return {
      showPostCreator: false
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated", "currentUser"])
  },

  methods: {
    openPostCreator() {
      if (!this.isAuthenticated) {
        this.$router.push("#auth")
        return
      }

      this.showPostCreator = true
      this.$router.push("#post-creator")
    },

    handleClose() {
      this.showPostCreator = false
      this.$router.removeHash()
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

$button--size: 48px;

.new-post-button {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  padding-top: 0;
  padding-bottom: 0;
  height: $button--size;

  .v-icon {
    top: 0;
  }
}
</style>
